module.exports = __webpack_public_path__ + "images/feature/20150520_project_stats_03-6208735975ebe5bb70f10059190fe4bd.png";